import React from "react";

export const LOGISTICS_RFQ_LIST_SCOPE_TABS = [
  { id: "all", label: "All RFQs" },
  { id: "mine", label: "My Assigned RFQs" },
];

export default function LogisticsRfqListScopeTabs({ activeScope = "all", onChange }) {
  return (
    <div className="sa-dispute-card-toolbar brrq-admin-scope-tabs">
      <div className="sa-dispute-tabs" role="tablist" aria-label="RFQ list views">
        {LOGISTICS_RFQ_LIST_SCOPE_TABS.map((tab) => (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={activeScope === tab.id}
            className={`sa-dispute-tabs__btn${
              activeScope === tab.id ? " sa-dispute-tabs__btn--active" : ""
            }`}
            onClick={() => onChange?.(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
}
